'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useRouter, useSearchParams } from 'next/navigation';
import { Suspense, useEffect, useState } from 'react';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { PortalRememberCard } from '@/features/portal/components/auth/PortalRememberCard';
import { portalClearLoginRemember, portalGetLoginRememberHint, portalUseLoginRemember } from '@/features/portal/store/actions';
import { selectPortalRememberHint } from '@/features/portal/store/selectors';
import { AuthShell } from '@/shared/components/layout';
import { LoadingScreen } from '@/shared/components/ui/common/LoadingScreen';
import { clearRecentPortalLoginIdentifier } from '@/shared/utils/recentPortalLoginIdentifier';
import { destinoSentencaPortal } from '@/shared/utils/destinoSentencaPortal';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
function LoginPageContent() {
  const $ = _c(20);
  const router = useRouter();
  const searchParams = useSearchParams();
  const dispatch = useAppDispatch();
  const rememberHint = useAppSelector(selectPortalRememberHint);
  const [mounted, setMounted] = useState(false);
  const [continuing, setContinuing] = useState(false);
  const [forgetting, setForgetting] = useState(false);
  let t0;
  let t1;
  if ($[0] !== dispatch) {
    t0 = () => {
      setMounted(true);
      dispatch(portalGetLoginRememberHint());
    };
    t1 = [dispatch];
    $[0] = dispatch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== continuing || $[4] !== dispatch || $[5] !== rememberHint || $[6] !== router || $[7] !== searchParams) {
    t2 = async () => {
      if (!rememberHint || continuing) {
        return;
      }
      setContinuing(true);
      const result = await dispatch(portalUseLoginRemember({
        canalId: null,
        redirectTo: destinoSentencaPortal(searchParams.get("redirect"))
      }));
      if (portalUseLoginRemember.fulfilled.match(result)) {
        router.push("/login/canal");
        return;
      }
      setContinuing(false);
    };
    $[3] = continuing;
    $[4] = dispatch;
    $[5] = rememberHint;
    $[6] = router;
    $[7] = searchParams;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleContinue = t2;
  let t3;
  if ($[9] !== dispatch || $[10] !== forgetting) {
    t3 = async () => {
      if (forgetting) {
        return;
      }
      setForgetting(true);
      clearRecentPortalLoginIdentifier();
      await dispatch(portalClearLoginRemember());
      setForgetting(false);
    };
    $[9] = dispatch;
    $[10] = forgetting;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleForget = t3;
  if (!mounted) {
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <LoadingScreen />;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex h-10 items-center"><Image src="/LogoCleanSm.svg" alt="Arbitralis" width={160} height={26} priority={true} className="h-auto w-40" /></div>;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== continuing || $[15] !== forgetting || $[16] !== handleContinue || $[17] !== handleForget || $[18] !== rememberHint) {
    t5 = <AuthShell contentAlignment="center" header={t4}>{rememberHint ? <div className="flex w-full flex-col gap-8"><div className="space-y-3"><h1 className="text-2xl leading-tight font-semibold tracking-tight text-neutral-900 sm:text-3xl">Boas-vindas de volta</h1><p className="text-base leading-relaxed text-neutral-600">Continue com o acesso salvo neste dispositivo.</p></div><PortalRememberCard hint={rememberHint} onContinue={handleContinue} onForget={handleForget} isContinuing={continuing} isForgetting={forgetting} /></div> : <LoginForm />}</AuthShell>;
    $[14] = continuing;
    $[15] = forgetting;
    $[16] = handleContinue;
    $[17] = handleForget;
    $[18] = rememberHint;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}
export default function LoginPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={<LoadingScreen />}><LoginPageContent /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}